<div class="main-container-position">
  <div class="container-width">
    <div class="py-8">
      <div class="flex items-center justify-between mb-8 flex-wrap">
        <div class="flex items-center space-x-2 order-1 md:order-none">
          <a routerLink="/company" class="text-black hover:cursor-pointer" i18n
            >Angebot Übersicht</a
          >
          <span class="text-gray-400">→</span>
          <span class="font-semibold text-black" i18n>{{
            isEditMode
              ? "Angebot bearbeiten"
              : "Angebot
            hinzufügen"
          }}</span>
        </div>
      </div>

      <!-- Modification Feedback Section -->
      @if (latestModificationFeedback) {
        <div class="mb-6">
          <div
            class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-2 gap-2"
          >
            <button
              (click)="toggleModificationFeedback()"
              class="flex items-center space-x-2 text-blue-600 hover:text-blue-800"
            >
              <mat-icon>{{
                showModificationFeedback ? "expand_less" : "expand_more"
              }}</mat-icon>
              <span i18n>Angeforderter Änderungen anzeigen</span>
            </button>
            <a
              [routerLink]="['/feedback-history', offerId]"
              class="flex items-center text-blue-600 hover:text-blue-800"
            >
              <mat-icon class="mr-1">history</mat-icon>
              <span i18n>Feedback-Historie ansehen</span>
            </a>
          </div>
          @if (showModificationFeedback) {
            <div class="mt-4">
              <app-feedback-details
                [feedback]="latestModificationFeedback"
                [categories]="categories"
                [offerTypes]="offerTypes"
              ></app-feedback-details>
            </div>
          }
        </div>
      }

      <!-- <h1 class="text-2xl font-semibold mb-6" i18n>Angebot hinzufügen</h1> -->

      <form
        [formGroup]="angebotForm"
        (ngSubmit)="submit(false)"
        data-testid="add-offer-form"
      >
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div class="flex flex-col space-y-4">
            @if (userIsAdmin) {
              <div>
                <label
                  for="companyId"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  i18n
                  >Firma</label
                >
                <mat-form-field class="w-full" data-testid="company-field">
                  <mat-label i18n>Firma auswählen</mat-label>
                  <mat-select
                    formControlName="companyId"
                    data-testid="company-select"
                    aria-label="Firma auswählen"
                  >
                    @for (company of companies$ | async; track company) {
                      <mat-option
                        [value]="company.id"
                        [attr.data-testid]="'company-option-' + company.id"
                      >
                        {{ company.companyName }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            <div>
              <label
                for="titel"
                class="block text-sm font-medium text-gray-700 mb-1"
                i18n
                >Titel</label
              >
              <mat-form-field class="w-full">
                <input
                  matInput
                  type="text"
                  formControlName="titel"
                  placeholder="Titel hinzufügen"
                  i18n-placeholder
                  data-testid="title-input"
                />
                @if (angebotForm.get("titel")?.errors?.["required"]) {
                  <mat-error i18n> Titel ist erforderlich </mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <label
                for="offerType"
                class="block text-sm font-medium text-gray-700 mb-1"
                i18n
                >Angebotstyp</label
              >
              <mat-form-field class="w-full" data-testid="offer-type-field">
                <mat-label data-testid="offer-type-select-label" i18n
                  >Angebotstyp auswählen</mat-label
                >
                <mat-select
                  formControlName="offerType"
                  data-testid="offer-type-select"
                  data-e2e-offer-type-select="true"
                  aria-label="Angebotstyp auswählen"
                  panelClass="offer-type-panel"
                >
                  <mat-select-trigger
                    data-testid="offer-type-trigger"
                    data-e2e-offer-type-trigger="true"
                  >
                    @if (selectedOfferType) {
                      <div class="flex items-center">
                        <mat-icon class="mr-2">{{
                          selectedOfferType.icon
                        }}</mat-icon>
                        <span>{{ selectedOfferType.offerName }}</span>
                      </div>
                    }
                  </mat-select-trigger>
                  @for (type of offerTypes; track type) {
                    <mat-option
                      [value]="type.id"
                      [attr.data-testid]="'offer-type-option-' + type.id"
                      [attr.data-e2e-offer-type-option]="type.id"
                      [attr.data-e2e-offer-type-name]="type.offerName"
                    >
                      <div class="flex items-center">
                        <mat-icon class="mr-2">{{ type.icon }}</mat-icon>
                        <span>{{ type.offerName }}</span>
                      </div>
                    </mat-option>
                  }
                </mat-select>
                @if (angebotForm.get("offerType")?.errors?.["required"]) {
                  <mat-error i18n> Angebotstyp ist erforderlich </mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <label
                for="categories"
                class="block text-sm font-medium text-gray-700 mb-1"
                i18n
                >Kategorien</label
              >
              <mat-form-field class="w-full" data-testid="categories-field">
                <mat-label i18n>Kategorien</mat-label>
                <mat-select
                  formControlName="categories"
                  multiple
                  data-testid="categories-select"
                  aria-label="Kategorien"
                  panelClass="categories-panel"
                >
                  @for (
                    category of availableCategories | async;
                    track category
                  ) {
                    <mat-option
                      [value]="category.id"
                      [attr.data-testid]="'category-option-' + category.id"
                    >
                      {{ category.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (angebotForm.get("categories")?.errors?.["required"]) {
                  <mat-error i18n>
                    Mindestens eine Kategorie ist erforderlich
                  </mat-error>
                }
              </mat-form-field>

              <div class="selected-categories flex flex-wrap gap-2 mt-2">
                @if (angebotForm.get("categories")?.value?.length) {
                  <mat-chip-set>
                    @for (
                      categoryId of angebotForm.get("categories")?.value;
                      track categoryId
                    ) {
                      <mat-chip>
                        {{ getCategoryName(categoryId) }}
                      </mat-chip>
                    }
                  </mat-chip-set>
                }
              </div>
            </div>

            <!-- Location Selector -->
            <div>
              <div class="flex items-center">
                <label
                  for="locations"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  i18n
                  >Wo soll Ihr Angebot verfügbar sein?</label
                >
                <mat-icon
                  class="ml-1 text-gray-500 cursor-help text-sm"
                  matTooltip="Wählen Sie die Standorte aus, an denen das Angebot verfügbar sein soll. Sie können ganz Österreich oder spezifische Bundesländer, Bezirke und Orte auswählen."
                  matTooltipClass="info-tooltip"
                  >help_outline</mat-icon
                >
              </div>
              @if (allIndexableLocations && (offer || !isEditMode)) {
                <app-offer-location-selector
                  [locations]="allIndexableLocations"
                  [offer]="offer"
                  formControlName="locations"
                  data-testid="location-selector"
                ></app-offer-location-selector>
              }
              @if (angebotForm.get("locations")?.errors?.["required"]) {
                <mat-error i18n>
                  Bitte wählen Sie mindestens einen Standort aus
                </mat-error>
              }
              @if (angebotForm.get("locations")?.errors?.["stateRequired"]) {
                <mat-error i18n>
                  Bitte wählen Sie mindestens ein Bundesland aus
                </mat-error>
              }
            </div>

            @if (selectedOfferType?.requiresDate) {
              <div>
                <label
                  for="appointmentDateTime"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  i18n
                  >Termin</label
                >
                <div class="flex space-x-4">
                  <mat-form-field class="w-2/3">
                    <mat-label i18n>Datum auswählen</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      formControlName="appointmentDateTime"
                      [min]="minDate"
                      [matDatepickerFilter]="dateFilter"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if (
                      angebotForm.get("appointmentDateTime")?.errors?.[
                        "required"
                      ]
                    ) {
                      <mat-error i18n> Datum ist erforderlich </mat-error>
                    }
                    @if (
                      angebotForm.get("appointmentDateTime")?.errors?.[
                        "matDatepickerFilter"
                      ]
                    ) {
                      <mat-error i18n>
                        Das Datum darf nicht in der Vergangenheit liegen
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field class="w-1/3">
                    <mat-label i18n>Uhrzeit (optional)</mat-label>
                    <input
                      matInput
                      type="time"
                      formControlName="appointmentTime"
                    />
                  </mat-form-field>
                </div>
              </div>
            }
          </div>

          <div class="flex flex-col">
            <label
              for="videoUrl"
              class="block text-sm font-medium text-gray-700 mb-1"
              i18n
              >{{
                selectedOfferType?.acceptedMimeType === "video/*"
                  ? "Video URL"
                  : selectedOfferType?.acceptedMimeType === "application/pdf"
                    ? "PDF"
                    : "Bild"
              }}</label
            >

            @if (selectedOfferType?.acceptedMimeType === "video/*") {
              <mat-form-field class="w-full">
                <input
                  matInput
                  type="text"
                  formControlName="videoUrl"
                  placeholder="YouTube oder Vimeo URL eingeben"
                  i18n-placeholder
                  data-testid="video-url-input"
                />
                @if (angebotForm.get("videoUrl")?.errors?.["required"]) {
                  <mat-error i18n> Video URL ist erforderlich </mat-error>
                }
                @if (angebotForm.get("videoUrl")?.errors?.["pattern"]) {
                  <mat-error i18n>
                    Bitte geben Sie eine gültige YouTube oder Vimeo URL ein
                  </mat-error>
                }
              </mat-form-field>
            }

            @if (selectedOfferType?.acceptedMimeType !== "video/*") {
              <div class="relative border border-gray-300 rounded-md p-2">
                <div
                  class="w-full h-64 flex justify-center items-center bg-gray-100"
                >
                  @if (selectedFileUrl) {
                    @if (
                      selectedOfferType?.acceptedMimeType === "application/pdf"
                    ) {
                      <div class="flex flex-col items-center space-y-2">
                        <mat-icon class="h-4 w-4">picture_as_pdf</mat-icon>
                        <div class="text-center">
                          <div class="font-medium">
                            {{ selectedFile?.name || editModeFileName }}
                          </div>
                          @if (selectedFile?.size) {
                            <div class="text-sm text-gray-500">
                              {{
                                (
                                  (selectedFile?.size || 0) /
                                  1024 /
                                  1024
                                ).toFixed(2)
                              }}
                              MB
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (
                      selectedOfferType?.acceptedMimeType !== "application/pdf"
                    ) {
                      <img
                        [src]="selectedFileUrl"
                        alt="Selected Image"
                        class="w-full h-full object-contain rounded-md"
                      />
                    }
                  }
                  <ng-template #noImage>
                    <span class="text-gray-500" i18n>{{
                      getTextForUploadField()
                    }}</span>
                  </ng-template>
                </div>
                <div class="text-sm text-gray-500 mt-1" i18n>Max. 10MB</div>
                <input
                  type="file"
                  (change)="onFileChange($event)"
                  [accept]="acceptedMimeTypes || undefined"
                  class="mt-2 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                  data-testid="file-input"
                />
              </div>
            }
          </div>
        </div>

        <div class="mb-6">
          <label
            for="beschreibung"
            class="block text-sm font-medium text-gray-700 mb-1"
            i18n
            >Beschreibung</label
          >
          <div class="NgxEditor__Wrapper">
            <ngx-editor-menu
              [editor]="editor"
              [toolbar]="toolbar"
            ></ngx-editor-menu>
            <ngx-editor
              [editor]="editor"
              formControlName="beschreibung"
              [placeholder]="'Beschreibung hinzufügen'"
            ></ngx-editor>
          </div>
          @if (angebotForm.get("beschreibung")?.errors?.["required"]) {
            <mat-error class="mt-1" i18n>
              Beschreibung ist erforderlich
            </mat-error>
          }
        </div>

        <div class="flex justify-end space-x-2">
          @if (isEditMode) {
            <button
              type="button"
              (click)="submit(false)"
              [disabled]="!angebotForm.valid || isSubmitting"
              [class.button-loading]="isSubmitting"
              class="bg-blue-500 text-white py-2 px-4 rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              i18n
              data-testid="submit-btn"
            >
              {{
                isSubmitting ? "Wird gespeichert..." : "Änderungen speichern"
              }}
            </button>
          } @else {
            <button
              type="button"
              (click)="submit(false)"
              [disabled]="
                !angebotForm.valid ||
                (!selectedFile &&
                  selectedOfferType?.acceptedMimeType !== 'video/*') ||
                isSubmitting
              "
              [class.button-loading]="isSubmitting"
              class="bg-blue-500 text-white py-2 px-4 rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              i18n
              data-testid="submit-btn"
            >
              {{ isSubmitting ? "Wird eingereicht..." : "Angebot einreichen" }}
            </button>
            <button
              type="button"
              (click)="submit(true)"
              [disabled]="
                !angebotForm.valid ||
                (!selectedFile &&
                  selectedOfferType?.acceptedMimeType !== 'video/*') ||
                isSubmitting
              "
              [class.button-loading]="isSubmitting"
              class="bg-blue-500 text-white py-2 px-4 rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              i18n
              data-testid="submit-create-another-btn"
            >
              {{
                isSubmitting
                  ? "Wird eingereicht..."
                  : "Einreichen und weitere erstellen"
              }}
            </button>
          }
        </div>
      </form>
    </div>
  </div>
</div>
